export enum CaapsTypes {
    Chapter,
    Annex,
    Article,
    Part,
    Section,
    Table,
    AnnexGroup,
}
